import { ContentCopy } from "@mui/icons-material";
import {Invitation, w2d2dApiClient} from "../../../w2d2d-api-client.ts";
import {Box, IconButton, Snackbar, Stack, Typography} from "@mui/material";
import {useCallback, useState} from "react";
import FullSizeBox from "../../../../appfw/ui/components/FullSizeBox.tsx";

interface ShareInvitationProps {
    readonly invitation: Invitation;
}

export default function ShareInvitation(props: ShareInvitationProps) {

    const link = w2d2dApiClient.appBaseUrl + 'invitations/' + props.invitation.id

    const [openHint, setOpenHint] = useState(false)

    let handleClick = useCallback(async () => {
        await navigator.clipboard.writeText(link)
        setOpenHint(true)
    }, [props.invitation, setOpenHint])

    const handleClose = () => {
        setOpenHint(false)
    }

    return (
        <FullSizeBox centerVertically={true}>

            <Typography variant="h5">
                Hier ist der Link zu Deiner Einladung
            </Typography>
            <Stack
                key={`${props.invitation.id}-invitation-link`}
                direction="row"
                padding={2}
            >
                <Box>
                    <Snackbar
                        open={openHint}
                        autoHideDuration={4000}
                        onClose={handleClose}
                        message={`Der Link wurde in die Zwischenablage kopiert.`}
                    />
                    <IconButton
                        onClick={handleClick}
                    >
                        <ContentCopy
                            cursor="pointer"
                            sx={{
                                height: "14px",
                                width: "14px",
                            }}
                        />
                    </IconButton>
                </Box>
                <Typography variant="subtitle1">
                    {link}
                </Typography>
            </Stack>
        </FullSizeBox>
    )
}